import { API_BASE_URL } from "@/config";
import { validate_registration_number } from "@/utils/validations.js";
import { useToast } from '@/components/Toast/useToast';

export default {
    name: 'CompanyBankAccountForm',
    setup() {
        const { showSuccess, showError } = useToast();
        
        return {
            showSuccess,
            showError
        };
    },
    data() {
        return {
            form: {
              company_name: '',
              reg1: '',
              reg2: '',
              reg3: '',
              bank_name: '',
              branch_code: '',
              bank_account: '',
              account_type: '',
              email_address: '',
              company_registration: ''
            },
            banks: [],
            account_types: [],
            error: '',
            json_data: {},
            error_messages: {
              company_name: '',
              company_registration: '',
              bank_name: '',
              branch_code: '',
              bank_account: '',
              account_type: '',
              email_address: ''
            }
        };
    },
    emits: ['service_status_complete'],
    watch: {
        'form.company_registration': function(new_val) {
            // Assuming the appropriate length for validation is 14 (e.g. "1234/567890/12")
            if (new_val && new_val.length >= 12) {
                // Create a mock event to pass to validate_reg_number
                const event = {
                    target: {
                        value: new_val,
                        selectionStart: new_val.length
                    },
                    key: ''
                };
                this.validate_reg_number(event);
            }
        }
    },
    methods: {
        validate_reg_number(event) {
            const position = event.target.selectionStart;
            if (event.key === 'Backspace' && position === 0) return;

            const { formatted_registration, new_cursor_pos, reg1, reg2, reg3 } = validate_registration_number(event.target.value, position);

            this.form.company_registration = formatted_registration;
            this.form.reg1 = reg1;
            this.form.reg2 = reg2;
            this.form.reg3 = reg3;

            this.$nextTick(() => {
                event.target.selectionStart = event.target.selectionEnd = new_cursor_pos;
            });
        },

        get_banks() {
            const TOKEN = localStorage.getItem('token');
            const GET_BANKS_URL = `${API_BASE_URL}/verify_api/customer_management_api/get_banks/`;

            $.ajax({
                url: GET_BANKS_URL,
                method: 'GET',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                success: (response) => {
                    this.banks = response.map(bank => ({ id: bank.id, name: bank.bank_name }));
                },
                error: () => {
                    console.error('Failed to fetch banks');
                }
            });
        },

        get_account_types() {
            const TOKEN = localStorage.getItem('token');
            const GET_ACCOUNT_TYPES_URL = `${API_BASE_URL}/verify_api/customer_management_api/get_account_types/`;

            $.ajax({
                url: GET_ACCOUNT_TYPES_URL,
                method: 'GET',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                success: (response) => {
                    this.account_types = response.map(acc => ({ id: acc.id, name: acc.account_type }));
                },
                error: () => {
                    console.error('Failed to fetch account types');
                }
            });
        },

        validate_fields() {
            this.error_messages = {};

            if (!this.form.email_address) {
                this.error_messages.email_address = 'Email address is required';
            }
            if (!this.form.company_name) {
                this.error_messages.company_name = 'Company name is required';
            }
            if (!this.form.company_registration) {
                this.error_messages.company_registration = 'Company registration is required';
            }
            if (!this.form.bank_name) {
                this.error_messages.bank_name = 'Bank name is required';
            }
            if (!this.form.account_type) {
                this.error_messages.account_type = 'Account type is required';
            }
            if (!this.form.bank_account) {
                this.error_messages.bank_account = 'Bank account is required';
            }
            if (!this.form.branch_code) {
                this.error_messages.branch_code = 'Branch code is required';
            }

            return Object.keys(this.error_messages).length === 0;
        },

        handle_submit() {
            if (!this.validate_fields()) {
                return;
            }

            const email_pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!email_pattern.test(this.form.email_address)) {
                this.error_messages.email_address = 'Email address format is invalid';
                return;
            }

            const TOKEN = localStorage.getItem('token');
            const COMPANY_BANK_ACCOUNT_API = `${API_BASE_URL}/verify_api/instant_verify_api/company_bank_account_verify/`;

            this.error = '';

            $.ajax({
                url: COMPANY_BANK_ACCOUNT_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    company_name: this.form.company_name,
                    reg1: this.form.reg1,
                    reg2: this.form.reg2,
                    reg3: this.form.reg3,
                    bank_name: this.form.bank_name,
                    branch_code: this.form.branch_code,
                    bank_account: this.form.bank_account,
                    account_type: this.form.account_type,
                    email_address: this.form.email_address
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });
                },
                success: () => {
                    Swal.close();
                    this.showSuccess('Successful', 'Company bank account verification ran successfully', 3000);
                    this.$emit('service_status_complete');
                    this.form.company_name = '';
                    this.form.reg1 = '';
                    this.form.reg2 = '';
                    this.form.reg3 = '';
                    this.form.bank_name = '';
                    this.form.branch_code = '';
                    this.form.bank_account = '';
                    this.form.account_type = '';
                    this.form.email_address = '';
                    this.form.company_registration = '';
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'Something went wrong!';

                    if (error.responseJSON && error.responseJSON.message) {
                        error_message = error.responseJSON.message;
                    }

                    this.showError('Error', error_message);
                }
            });
        }
    },
    mounted() {
        this.get_banks();
        this.get_account_types();
    }
};
